/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import CSSModules from 'react-css-modules';
import React from 'react';
import isNil from 'lodash/isNil';
import {
  Button,
  Modal,
  Navbar,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { injectIntl } from 'react-intl';
import HideIf from 'loracoms/HideIf';
import SearchInput from 'loracoms/SearchInput';
import ShowIf from 'loracoms/ShowIf';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles.scss';
import imgList from './images/list.svg';
import imgMap from './images/map.svg';
import imgLog from './images/log.svg';

import GatewayList from './coms/GatewayList';
import Map from './coms/Map';
import GatewayLog from './coms/GatewayLog';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  plan: React.PropTypes.object.isRequired,
  basic: React.PropTypes.object.isRequired,
  usage: React.PropTypes.object.isRequired,
  gotoBilling: React.PropTypes.func.isRequired,
  gotoGatewayAdd: React.PropTypes.func.isRequired,
};

class Gateway extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: props.plan,
      basic: props.basic,
      usage: props.usage,
      view: 'list',
    };
    this.intlMsg = new IntlMsg(props.intl, 'gateway');
    this.handleCreateGateway = this.handleCreateGateway.bind(this);
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const { plan, basic, usage } = nextProps;
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
    if (basic !== this.props.basic) {
      this.setState({ basic });
    }
    if (usage !== this.props.usage) {
      this.setState({ usage });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleCreateGateway() {
    const { gotoGatewayAdd } = this.props;
    const {
      usage,
      basic: { data: basicData },
    } = this.state;
    if (usage.gateways >= basicData.lrgatewaynum) {
      // out of quota
      this.setState({
        addError: 'ooq',
      });
      return;
    }

    gotoGatewayAdd();
  }

  renderAddErrorModal() {
    const { gotoBilling } = this.props;
    const { addError, plan: { data: planData } } = this.state;

    if (addError === 'ooq') {
      return (
        <Modal
          bsClass="aisz-modal-warning"
          show={!isNil(this.state.addError)}
          onHide={() => this.setState({ addError: null })}
        >
          <Modal.Header closeButton>
            <div className="text-center">
              <i className="fa fa-exclamation-triangle" aria-hidden="true" />
              {' '}
              { this.intlMsg.msg('addgateway.adderr.modalheader') }
            </div>
          </Modal.Header>
          <Modal.Body>
            <HideIf if="profile:cube">
              <span>
                <ShowIf if={planData.tier < 3}>
                  <div className="text-center">
                    <p>
                      { this.intlMsg.msg('addgateway.adderr.outofquota.undercomm') }
                    </p>
                    <Button
                      bsStyle="aisz-primary"
                      onClick={gotoBilling}
                    >
                      { this.intlMsg.msg('addgateway.adderr.upgrade') }
                      {' '}
                      <i className="fa fa-arrow-circle-o-right" aria-hidden="true" />
                    </Button>
                  </div>
                </ShowIf>
                <ShowIf if={planData.tier === 3}>
                  <div className="text-center">
                    <p>
                      { this.intlMsg.msg('addgateway.adderr.outofquota.comm') }
                    </p>
                    <a href="mailto:support@aisenz.com">support@aisenz.com</a>
                  </div>
                </ShowIf>
              </span>
            </HideIf>
            <ShowIf if="profile:cube">
              <div className="text-center">
                <p>
                  { this.intlMsg.msg('addgateway.adderr.outofquota.cube') }
                </p>
                <a href="mailto:support@aisenz.com">support@aisenz.com</a>
              </div>
            </ShowIf>
          </Modal.Body>
        </Modal>
      );
    }

    return null;
  }

  renderContent() {
    const {
      view,
      listSearch,
      gwlist,
      mapSearch,
      showSearchFlag = false,
    } = this.state;

    if (view === 'list') {
      return <GatewayList search={listSearch} showSearchFlag={showSearchFlag} />;
    } else if (view === 'map') {
      return <Map gwlist={gwlist} search={mapSearch} />;
    } else if (view === 'log') {
      return <GatewayLog />;
    }
    return null;
  }

  renderToolbar() {
    const { view, listSearch = '', mapSearch = '' } = this.state;

    if (view === 'list') {
      return (
        <Navbar.Form pullRight>
          <SearchInput
            autoFocus
            placeholder={this.intlMsg.msg('list.search.placeholder')}
            value={listSearch}
            onChange={e => this.setState({ listSearch: e.target.value.trim() })}
            onFocus={() => this.setState({ showSearchFlag: true })}
            onBlur={() => this.setState({ showSearchFlag: false })}
          />
        </Navbar.Form>
      );
    } else if (view === 'map') {
      return (
        <Navbar.Form pullRight>
          <SearchInput
            value={mapSearch}
            placeholder={this.intlMsg.msg('map.search.placeholder')}
            onChange={e => this.setState({ mapSearch: e.target.value.trim() })}
          />
        </Navbar.Form>
      );
    }
    return null;
  }

  render() {
    const { view } = this.state;
    const tpList = <Tooltip id="tplist"> {this.intlMsg.msg('tooltip.list')} </Tooltip>;
    // const tpMap = <Tooltip id="tpmap"> {this.intlMsg.msg('tooltip.map')} </Tooltip>;
    const tpLog = <Tooltip id="tplog"> {this.intlMsg.msg('tooltip.log')} </Tooltip>;

    return (
      <div styleName="wrapper" style={{ minHeight: window.innerHeight - 50 }}>
        <div styleName="toolbar">
          <Navbar collapseOnSelect bsStyle="aisz-white">
            <Navbar.Header>
              <Navbar.Brand>
                <span className={`halflings halflings-menu-hamburger ${styles.brandIcon}`} />
              </Navbar.Brand>
              <Navbar.Form>
                <Button bsStyle="aisz-success" onClick={this.handleCreateGateway}>
                  { this.intlMsg.msg('gateway') }
                  {' '}
                  <span className="glyphicon glyphicon-plus" />
                </Button>
                <div styleName="view-opts">
                  <OverlayTrigger overlay={tpList} placement="top">
                    <Link
                      styleName={`view-opt ${view === 'list' ? ' active' : ''}`}
                      onClick={() => this.setState({ view: 'list' })}
                    >
                      <img src={imgList} alt="" />
                    </Link>
                  </OverlayTrigger>
                  {/* <OverlayTrigger overlay={tpMap} placement="top">
                    <Link
                      styleName={`view-opt ${view === 'map' ? ' active' : ''}`}
                      onClick={() => this.setState({ view: 'map' })}
                    >
                      <img src={imgMap} alt="" />
                    </Link>
                  </OverlayTrigger> */}
                  <OverlayTrigger overlay={tpLog} placement="top">
                    <Link
                      styleName={`view-opt ${view === 'log' ? ' active' : ''}`}
                      onClick={() => this.setState({ view: 'log' })}
                    >
                      <img src={imgLog} alt="" />
                    </Link>
                  </OverlayTrigger>
                </div>
              </Navbar.Form>
              <Navbar.Toggle>
                <i className="fa fa-caret-down" />
              </Navbar.Toggle>
            </Navbar.Header>
            <Navbar.Collapse>
              {this.renderToolbar()}
            </Navbar.Collapse>
          </Navbar>
        </div>

        <div styleName="content">
          {this.renderContent()}
        </div>
        <div>
          {this.renderAddErrorModal()}
        </div>
      </div>
    );
  }
}

Gateway.propTypes = propTypes;

const mapStateToProps = state => ({
  plan: state.billing.plan,
  basic: state.org.basic,
  usage: state.usage,
});

const mapDispatchToProps = dispatch => ({
  gotoGatewayAdd: () => dispatch(push('/gateway/add')),
  gotoBilling: () => dispatch(push('/billing/plans')),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  injectIntl(CSSModules(Gateway, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Gateway/index.jsx